export const FETCH_PAGINATED_TEMPLATES = 'templates/fetchPaginatedTemplates';
